import { useFeatureFlags } from 'utils/features';

export default function useSchedulingWeeklyAttendanceReportEnabled() {
  // Pro feature is baked into launch darkly
  const isFeatureEnabled = useFeatureFlags('ATTENDANCE_REPORT');
  return isFeatureEnabled;
}
